import React from 'react';
import { motion } from 'framer-motion';
import { Scissors, MapPin, Instagram, Star } from 'lucide-react';
export function Hero() {
  const handleWhatsApp = () => {
    window.open('https://wa.me/59892738664?text=Hola%20Okrim!%20Quería%20consultar%20para%20agendar%20un%20turno.', '_blank');
  };
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-zinc-950" data-id="element-134">
      {/* Premium Texture Overlay */}
      <div className="absolute inset-0 grain-overlay opacity-20 mix-blend-overlay pointer-events-none z-10" data-id="element-135"></div>

      {/* Background "OKRIM" brush wordmark */}
      <div className="absolute inset-0 z-0 flex items-center justify-center overflow-hidden pointer-events-none" data-id="element-136">
        {/* Red halo / aura glow behind the wordmark */}
        <motion.div aria-hidden="true" initial={{
        opacity: 0
      }} animate={{
        opacity: [0.5, 0.9, 0.5],
        scale: [1, 1.06, 1]
      }} transition={{
        duration: 4.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute w-[75vw] h-[55vh] rounded-full bg-red-600/45 blur-[120px]" data-id="element-137" />
        <motion.span aria-hidden="true" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 2,
        ease: 'easeOut'
      }} className="relative select-none font-brush text-zinc-900 leading-none text-[58vw] md:text-[44vw] whitespace-nowrap -rotate-2 drop-shadow-[0_0_70px_rgba(220,38,38,0.6)]" data-id="element-138">
          Okrim
        </motion.span>
        {/* Vignette effect to blend edges into darkness */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,#09090b_80%)] z-10" data-id="element-139"></div>
      </div>

      <div className="container mx-auto px-6 relative z-20 flex flex-col items-center text-center pt-28 pb-28 sm:pt-24 sm:pb-32" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-4xl flex flex-col items-center" data-id="element-141">
          {/* Logo-style divider */}
          <div className="flex items-center justify-center gap-3 sm:gap-4 mb-6 sm:mb-8 opacity-80" data-id="element-142">
            <div className="w-10 sm:w-16 h-[1px] bg-zinc-700 relative" data-id="element-143">
              <div className="absolute -left-1 -top-[3px] w-1.5 h-1.5 rounded-full bg-zinc-500" data-id="element-144"></div>
            </div>
            <Scissors size={18} className="text-red-600" data-id="element-145" />
            <div className="w-10 sm:w-16 h-[1px] bg-zinc-700 relative" data-id="element-146">
              <div className="absolute -right-1 -top-[3px] w-1.5 h-1.5 rounded-full bg-zinc-500" data-id="element-147"></div>
            </div>
          </div>

          <h1 className="font-display text-[3.25rem] leading-[0.9] sm:text-6xl md:text-8xl lg:text-[8rem] font-bold uppercase tracking-tighter text-zinc-50 mb-5 sm:mb-6 sm:leading-[0.85]" data-id="element-148">
            Cortes que{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-700" data-id="element-149">
              elevan
            </span>{' '}
            <br data-id="element-150" />
            tu imagen
          </h1>

          <p className="text-base sm:text-lg md:text-xl text-zinc-400 font-light max-w-md sm:max-w-2xl mx-auto mb-8 sm:mb-10 leading-relaxed px-2" data-id="element-151">
            Especialistas en Fade, diseño de barba y asesoría de imagen
            personalizada.
            <br data-id="element-152" />
            <span className="sm:whitespace-nowrap" data-id="element-153">
              Tu mejor versión empieza acá, en el Centro de Montevideo.
            </span>
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 w-full sm:w-auto" data-id="element-154">
            <button onClick={handleWhatsApp} className="group relative w-full sm:w-auto px-10 py-4 sm:py-5 bg-red-600 text-zinc-50 font-display uppercase tracking-widest text-sm font-bold overflow-hidden transition-all hover:scale-105 active:scale-95 shadow-[0_0_40px_rgba(220,38,38,0.25)] hover:shadow-[0_0_60px_rgba(220,38,38,0.4)]" data-id="element-155">
              {/* Barber stripe hover effect */}
              <div className="absolute inset-0 barber-stripe opacity-0 group-hover:opacity-10 transition-opacity duration-500" data-id="element-156"></div>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" data-id="element-157"></div>
              <span className="relative flex items-center justify-center gap-3" data-id="element-158">
                Reservá tu turno
                <Scissors size={16} data-id="element-159" />
              </span>
            </button>

            <a href="https://instagram.com/okrim_barber" target="_blank" rel="noreferrer" className="group w-full sm:w-auto px-8 py-3 sm:py-5 text-zinc-300 font-display uppercase tracking-widest text-sm font-bold transition-all hover:text-zinc-50 flex items-center justify-center gap-3" data-id="element-160">
              <Instagram size={18} className="text-red-500 group-hover:scale-110 transition-transform" data-id="element-161" />
              <span className="relative" data-id="element-162">
                Ver trabajos
                <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-red-500 transition-all duration-300 group-hover:w-full" data-id="element-163"></span>
              </span>
            </a>
          </div>

          {/* Trust indicator */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1,
          duration: 1
        }} className="mt-10 sm:mt-16 flex items-center gap-3 text-sm text-zinc-500 font-medium" data-id="element-164">
            <div className="flex gap-1 text-red-500" data-id="element-165">
              {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" data-id="element-166" />)}
            </div>
            <span data-id="element-167">Más de 500 clientes satisfechos</span>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-1 left-1/2 -translate-x-1/2 hidden sm:flex flex-col items-center gap-3 z-20" data-id="element-168">
        <span className="text-[10px] text-zinc-500 font-display uppercase tracking-[0.3em]" data-id="element-169">
          Descubrí más
        </span>
        <div className="w-[1px] h-16 bg-gradient-to-b from-red-600/50 to-transparent relative overflow-hidden" data-id="element-170">
          <motion.div animate={{
          y: [0, 64]
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'linear'
        }} className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-transparent via-red-500 to-transparent" data-id="element-171" />
        </div>
      </motion.div>
    </section>;
}